import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ProfileInfoView } from '../View';
import { investorActions } from '../../../../../store/investor';
import { useQuery } from '@tanstack/react-query';
import { useLoadingState } from '@/hooks';

export const ProfileInfo = () => {
  const dispatch = useDispatch();
  const investor = useSelector((state) => state.investor);
  const { refetch, isFetching } = useQuery({
    queryKey: ['fetchProfile'],
    queryFn: () => investorActions.fetchProfile(dispatch),
    retry: 1,
    enabled: false
  });
  // useEffect(() => {
  //   dispatch(investorActions.getAdditionalInfo());
  // }, []);

  useLoadingState(isFetching);

  return <ProfileInfoView investor={investor} refetch={refetch} />;
};
